import React, { useState, useEffect } from 'react';

//Components
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import TabelaListagemFichas from '../../../components/TabelaListagemFichas/TabelaListagemFichas';


export default function TabelaCabecalho({ items = [], actions = [], ficha }) {
    //Estado de controle dos items
    const [cabecalhos, setCabecalhos] = useState([...items]);

    //Cabeçalhos da tabela de cabeçalhos
    const headersCabecalhos = [
        { value: "Sequência", objectValue: "sequencia" },
        { value: "Identificação", objectValue: "identificacao" },
        { value: "Tipo de valor", objectValue: "tipoValor" },
        { value: "Campo obrigatório", objectValue: "obrigatorio" },
    ]

    useEffect(() => {
        const _cabecalhos = items.map(value => {
            const _value = { ...value };
            _value.obrigatorio = _value.obrigatorio ? "Sim" : "Não";
            return _value;
        });
        setCabecalhos(_cabecalhos);
    }, [items]);
    if (ficha)
        return <TabelaListagemFichas headers={headersCabecalhos} items={cabecalhos} />

    return (
        <TabelaListagem actions={actions} headers={headersCabecalhos} items={cabecalhos} />
    )
}